import { Select, ISelect } from ".";
import { textChooser } from "../../../util/textChooser";
import { genderValues } from "../../../util/GlobalData";

interface GenderProps extends ISelect {
  defaultValue?: string | number
}

export const Gender = (props: GenderProps) => {
  return (
    <Select
      currentValue={props?.currentValue}
      values={genderValues}
      subLabel={textChooser("txt94")}
      hook={props?.hook}
      defaultValue={props?.defaultValue}
    />
  )
}